import { CardBackgroundViewModel } from '../../card-background-view-model';
import type { Observable } from 'rxjs';
import type { GlassHouseBrandGroupCardData } from '../../../../../../../models/print-cards/glass-house/glass-house-brand-group-card-data';
import { Injectable } from '@angular/core';

@Injectable()
export class GlassHouseBrandGroupThreeByFourStackBackgroundViewModel extends CardBackgroundViewModel {
  public readonly cardData$: Observable<GlassHouseBrandGroupCardData>;
}
